module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "aria-labelledby": "toc1",
      "epub:type": "toc",
      "role": "doc-toc"
    }
  }, [_c('h1', {
    staticClass: "chaptitle-pre",
    attrs: {
      "epub:type": "title",
      "id": "toc1"
    }
  }, [_c('span', {
    attrs: {
      "aria-label": "page vii",
      "epub:type": "pagebreak",
      "id": "page_vii",
      "role": "doc-pagebreak"
    }
  }, [_c('img', {
    staticClass: "symbol",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "Images/pipe-big.jpg"
    }
  }), _vm._v(" Contents")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1a"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/06_Acknowledgements"
    }
  }, [_c('i', [_vm._v("Acknowledgements")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1a"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/07_Introduction"
    }
  }, [_c('i', [_vm._v("Introduction")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/08_Chapter_01#chapter"
    }
  }, [_vm._v("  1 "), _c('img', {
    staticClass: "symbol",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "Images/pipe.jpg"
    }
  }), _vm._v(" Early Life: Orillia and the Red River Expedition, "), _c('span', {
    staticClass: "smallcap"
  }, [_vm._v("1848–1873")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1b"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/09_Chapter_02#chapter"
    }
  }, [_vm._v("  2 "), _c('img', {
    staticClass: "symbol",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "Images/pipe.jpg"
    }
  }), _vm._v(" The North-West Mounted Police, "), _c('span', {
    staticClass: "smallcap"
  }, [_vm._v("1873–1885")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1b"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/10_Chapter_03#chapter",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("  3 "), _c('img', {
    staticClass: "symbol",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "Images/pipe.jpg"
    }
  }), _vm._v(" Steele’s Scouts in the Rebellion, "), _c('span', {
    staticClass: "smallcap"
  }, [_vm._v("1885")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1b"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/11_Chapter_04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("  4 "), _c('img', {
    staticClass: "symbol",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "Images/pipe.jpg"
    }
  }), _vm._v(" Frustrated Ambition, "), _c('span', {
    staticClass: "smallcap"
  }, [_vm._v("1886–1888")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1b"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/12_Chapter_05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("  5 "), _c('img', {
    staticClass: "symbol",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "Images/pipe.jpg"
    }
  }), _vm._v(" The Love of His Life: Marie Harwood, "), _c('span', {
    staticClass: "smallcap"
  }, [_vm._v("1888–1890")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1b"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/13_Chapter_06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("  6 "), _c('img', {
    staticClass: "symbol",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "Images/pipe.jpg"
    }
  }), _vm._v(" Fort Macleod and Family, "), _c('span', {
    staticClass: "smallcap"
  }, [_vm._v("1890–1898")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1b"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/14_Chapter_07#chapter",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("  7 "), _c('img', {
    staticClass: "symbol",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "Images/pipe.jpg"
    }
  }), _vm._v(" The Klondike Gold Rush, "), _c('span', {
    staticClass: "smallcap"
  }, [_vm._v("1898–1899")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1b"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/15_Chapter_08#chapter",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("  8 "), _c('img', {
    staticClass: "symbol",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "Images/pipe.jpg"
    }
  }), _vm._v(" Fighting for Queen and Country: Lord Strathcona’s Horse, "), _c('span', {
    staticClass: "smallcap"
  }, [_vm._v("1899–1901")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1b"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/16_Chapter_09",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("  9 "), _c('img', {
    staticClass: "symbol",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "Images/pipe.jpg"
    }
  }), _vm._v(" Imperial Interlude: The South African Constabulary, "), _c('span', {
    staticClass: "smallcap"
  }, [_vm._v("1901–1907")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1b"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/17_Chapter_10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10 "), _c('img', {
    staticClass: "symbol",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "Images/pipe.jpg"
    }
  }), _vm._v(" Preparing for War, "), _c('span', {
    staticClass: "smallcap"
  }, [_vm._v("1907–1914")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1b"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/18_Chapter_11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11 "), _c('img', {
    staticClass: "symbol",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "Images/pipe.jpg"
    }
  }), _vm._v(" An Old Soldier Fades Away: General Steele, "), _c('span', {
    staticClass: "smallcap"
  }, [_vm._v("1914–1919")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1c"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/19_Epilogue",
      "title": "Link target outside of Sample"
    }
  }, [_c('img', {
    staticClass: "symbol",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "Images/pipe.jpg"
    }
  }), _vm._v(" Epilogue")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1aa1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/20_Notes",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Notes")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1aa"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/21_Bibliography",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Bibliography")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1aa"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/22_Index",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Index")])])]), _vm._v(" "), _c('span', {
    attrs: {
      "aria-label": "page viii is intentionally left as blank",
      "epub:type": "pagebreak",
      "id": "page_viii",
      "role": "doc-pagebreak"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ba250738","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/05_Contents.vue
// module id = 66
// module chunks = 0